import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Speedometer01 = function Speedometer01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2v2.5M12 2C6.4772 2 2 6.4772 2 12M12 2c5.5228 0 10 4.4772 10 10m-10 7.5V22m0 0c5.5228 0 10-4.4772 10-10M12 22C6.4772 22 2 17.5228 2 12m2.5 0H2m20 0h-2.5m-.4216 7.0784-1.7737-1.7737m-12.383 1.7737 1.7754-1.7755M4.9217 5l1.7365 1.7364M19.0784 5l-5.5785 5.5M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    })
  }));
};
export default Speedometer01;